// import { useDispatch } from "react-redux";
// import { getData, postData } from "../api/networkservices/networkServices";
import { getData, postData } from "../api/networkservices";
// import AsyncStorage from "@react-native-async-storage/async-storage";
// import { updateCurrUser } from "../redux/slices/userSlice";
// import updateCurrUser from "../redux/slices/rootSlices";
// import axios from "axios";
// import OneSignal from "react-native-onesignal";
// import { useSelector } from "react-redux";

export const getTodosfromAPI = async () => {
  const res = await fetch("https://jsonplaceholder.typicode.com/todos");
  return res.json();
};

export const getValuesFromLocal = (key) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error(`Error retrieving data for key "${key}":`, error);
    return null;
  }
};

export const getCurrentUserFromLocal = () => {
  try {
    const data = localStorage.getItem("currentUser");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error retrieving currentUser:", error);
    return null;
  }
};

export const setItemToLocal = (key, values) => {
  try {
    const jsonValue = JSON.stringify(values);
    localStorage.setItem(key, jsonValue);
  } catch (error) {
    console.error(`Error setting data for key "${key}":`, error);
  }
};

export const resendVerificationEmail = async (values) => {
  const data = await getData("/resend-verification-email/" + values);
  console.log("resend-verification-email", data);
  return data;
  // console.log("resend-verification-emailjs", data);
};

export const getSettings = async (values) => {
  const data = await getData("/getsettings/" + values);
  console.log("getsettings_api..........", data);
  return data;
};

export const getInterests = async (values) => {
  const data = await getData("/interests");
  console.log("getinterests_api..........", data);
  return data;
};
export const miscHome = async (values) => {
  const data = await getData("/misc-home");
  return data;
};
export const choosePlan = async (values) => {
  const data = await getData("/choose-plan");
  return data;
};
// interests

export const getIqAssessment = async (values) => {
  const data = await getData("/iq-assessment");
  console.log("iq-assessment..........", data);
  return data;
};
// iq-assessment
export const getTemperamentAssessment = async (values) => {
  const data = await getData("/temperament-assessment");
  console.log("temperament-assessment..........", data);
  return data;
};
// temperament-assessment
export const getValueAssessment = async (values) => {
  const data = await getData("/value-assessment");
  console.log("value-assessment..........", data);
  return data;
};
export const getBlogs = async (values) => {
  const data = await getData("/blogs");
  return data;
};
export const subscribeTonewsletter = async (values) => {
  const data = await postData("/subscribe-to-newsletter", values);
  return data;
};

export const GetStripeData = async (values) => {
  const data = await postData("/set-payment-intent", values);
  return data;
};
export const getActiveSubscription = async (values) => {
  const url = "/get-active-subscription/" + values;
  console.log("Final URL ===>", url);
  const data = await getData(url);
  return data;
};

export const login = async (values) => {
  const data = await postData("/userlogin", values);
  return data;
};
export const getinfluencercode = async (values) => {
  const data = await postData("/get-influencer-code", values);
  return data;
};
export const Influencerlogin = async (values) => {
  const data = await postData("/influencer-login", values);
  return data;
};
export const InfluencerInfo = async (values) => {
  const data = await postData("/influencer-info", values);
  return data;
};
export const InfluencerPasswordUpdate = async (values) => {
  const data = await postData("/influencer-password-update", values);
  return data;
};
export const checkInfluencerCode = async (values) => {
  const data = await postData("/check-influencer-code", values);
  if (data !== undefined) {
    return data;
  }
};
export const createOrUpdateMatchPreferences = async (values) => {
  const data = await postData("/create-or-update-match-preferences", values);
  return data;
};
export const Createorupdatelovelanguage = async (values) => {
  const data = await postData("/create-or-update-love-language", values);
  return data;
};

export const checkIfuserIsConnected = async (values) => {
  const data = await postData(
    "/check-if-user-is-connected-to-target-user",
    values
  );
  return data;
};
export const influencerfilterbydate = async (values) => {
  const data = await postData("/influencer-commission-filter-by-date", values);
  return data;
};
export const publicEnquiry = async (values) => {
  const data = await postData("/public-enquiry", values);
  return data;
};
export const miscFaqs = async (values) => {
  const data = await getData("/misc-faqs");
  return data;
};
export const miscAbout = async (values) => {
  const data = await getData("/misc-about ");
  return data;
};
export const UpdateLoveLanguage = async (values) => {
  const data = await postData("/create-or-update-love-language", values);
  return data;
};
export const getLoveLanguage = async (values) => {
  const data = await postData("/get-love-language", values);
  return data;
};
export const getAnswers = async (values) => {
  const data = await postData("/get-answers", values);
  return data;
};
export const getMoreProfile = async (values) => {
  const data = await postData("/get-user-more-profile", values);
  return data;
};
export const UpdateMoreProfile = async (values) => {
  const data = await postData("/create-or-update-profile-details", values);
  return data;
};
export const cancelRequest = async (values) => {
  const data = await postData("/undo-sent-connection-request", values);
  return data;
};
export const getConnections = async (values) => {
  const data = await postData("/get-connections", values);
  return data;
};
export const removeConnection = async (values) => {
  const data = await postData("/remove-connection", values);
  return data;
};
// export const cancelSubscription = async (values) => {
//   const data = await postData("/cancel-subscription", values);
//   return data;
// };
export const cancelSubscription = async (values) => {
  const url = "/cancel-active-subscription-end-of-cycle/" + values;
  console.log("Final URL end of cycle ===>", url);
  const data = await getData(url);
  return data;
};
export const currentSubscription = async (values) => {
  const data = await postData("/current-subscription", values);
  return data;
};
export const chatConnectionFeeList = async (values) => {
  const data = await postData("/connection-fee-list", values);
  return data;
};

export const InfluencerCodeSend = async (values) => {
  const data = await postData("/send-influencer-code-for-pwd-reset", values);
  return data;
};
export const getCurrentAdminFeefirst = async (values) => {
  const data = await postData("/get-current-admin-fee", values);
  return data;
};

export const completeZeroAdminFee = async (values) => {
  const data = await postData("/complete-zero-admin-fee", values);
  return data;
};
export const createOrUpdateProfileDetails = async (values) => {
  const data = await postData("/create-or-update-profile-details", values);
  return data;
};
export const getCountryList = async (values) => {
  const data = await getData("/get-country-list");
  return data;
};
export const changeEmail = async (values) => {
  const data = await postData("/update-email-for-email-verification", values);
  return data;
};

// /influencer-login

export const register = async (values) => {
  // Registration may wait on synchronous SMTP verification mail; keep other APIs at the default 5s timeout.
  const data = await postData("/userregistration", values, { timeout: 30000 });
  return data;
};
export const notInterested = async (values) => {
  const data = await postData("/mark-selected-user-as-not-interested", values);
  return data;
};
export const GetConnectionStatus = async (values) => {
  const data = await postData("/get-connection-status", values);
  return data;
};
export const sendSupport = async (values) => {
  const data = await postData("/send-support", values);
  return data;
};
export const getCounsellor = async (values) => {
  const data = await getData("/get-counsellors");
  return data;
};
export const myBookings = async (values) => {
  const data = await postData("/my-bookings", values);
  return data;
};
export const counsellorsBookedByMe = async (values) => {
  const data = await postData("/counsellors-booked-by-me", values);
  return data;
};
export const getPaymentHistory = async (values) => {
  const data = await postData("/payment-history", values);
  return data;
};
export const reportedByme = async (values) => {
  const data = await postData("/reported-by-me", values);
  return data;
};

// reported-by-me

export const ForgotPasswords = async (values) => {
  const data = await postData("/send-code-for-pwd-reset", values);
  return data;
};
export const ResetPassword = async (values) => {
  const data = await postData("/reset-password", values);
  return data;
};
export const counsellorRegistration = async (values) => {
  const data = await postData("/counsellor-registration", values);
  return data;
};
export const CounsellorBookings = async (values) => {
  const data = await postData("/counsellor-bookings", values);
  return data;
};
export const getCounsellorRatings = async (values) => {
  const data = await postData("/get-counsellor-ratings", values);
  return data;
};
export const checkCounsellorEmail = async (values) => {
  const data = await postData("/check-counsellor-email", values);
  console.log("data", data);
  if (data !== undefined) {
    return data;
  }
};
export const UpdateCounsellor = async (values) => {
  const data = await postData("/update-counsellor", values);
  return data;
};

export const ReportUser = async (values) => {
  const data = await postData("/report-user", values);
  return data;
};
export const CounsellorBookingDetails = async (values) => {
  const data = await postData("/counsellor-booking-details", values);
  return data;
};
export const connectionFeeList = async (values) => {
  const data = await getData("/connection-fee-list");
  return data;
};
export const SubmitReview = async (values) => {
  const data = await postData("/submit-review", values);
  return data;
};
export const sendTemperamentAssessment = async (values) => {
  const data = await postData("/create-temperament-assessment", values);
  return data;
};
export const sendIqAssessment = async (values) => {
  const data = await postData("/create-iq-assessment", values);
  return data;
};

export const matchedUsers = async (values) => {
  const data = await postData("/matched-users", values);
  return data;
};
export const getPendingRequests = async (values) => {
  const data = await postData("/get-pending-requests", values);
  return data;
};
export const notificationHistory = async (values) => {
  const data = await postData("/notification-history", values);
  return data;
};
export const appPageContents = async (values) => {
  const data = await postData("/app-page-contents", values);
  return data;
};

export const viewReceivedInterestRequests = async (values) => {
  const data = await postData("/view-received-interest-requests", values);
  return data;
};

export const removeImage = async (values) => {
  const data = await postData("/remove-existing-image", values);
  return data;
};

export const updateConnectUsers = async (values) => {
  const data = await postData("/update-connect-users", values);
  return data;
};
export const viewSentInterestRequests = async (values) => {
  const data = await postData("/view-sent-interest-requests", values);
  return data;
};
export const connectUsers = async (values) => {
  const data = await postData("/connect-users", values);
  return data;
};
export const fevoriteUsers = async (values) => {
  const data = await postData("/favorite-users", values);
  return data;
};

export const deleteUser = async (values) => {
  const data = await postData("/deluser", values);
  return data;
};
export const firstPayment = async (values) => {
  console.log("fristPayment from api");
  const data = await postData("/firstPayment", values);
  return data;
};

export const UpdateUser = async (values) => {
  const data = await postData("/updateuser", values);
  return data;
};
export const UpdateInterestss = async (values) => {
  const data = await postData("/update-interest", values);
  return data;
};

export const ResetPasswordEdit = async (values) => {
  const data = await postData("/reset-password", values);
  return data;
};

export const getUserById = async (values) => {
  // const subId = await OneSignal.User.pushSubscription.getIdAsync();

  const data = await postData("/getuserbyid", { ...values /* token: subId*/ });
  // console.log('getUserById++++++++++++++++++++', data);
  return data;
};

export const isUserExist = async (values) => {
  const data = await postData("/check-email", values);
  console.log("data", data);
  if (data !== undefined) {
    return data;
  }
};
